import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useSession } from '../lib/session';

/**
 * Guards a screen that has nothing to show a signed-out visitor.
 *
 * `loading` matters: on a hard reload the refresh token has not been exchanged
 * yet, so `member` is null for a moment. Redirecting during that window would
 * bounce a signed-in member to the sign-in screen every time they refreshed.
 */
export function RequireMember({ children }: { children: ReactNode }) {
  const { member, loading } = useSession();
  const location = useLocation();

  if (loading) {
    return (
      <main className="mx-auto max-w-[760px] px-6 py-14">
        <p className="text-body text-muted">Checking your session…</p>
      </main>
    );
  }

  if (!member) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/sign-in?next=${encodeURIComponent(next)}`} replace />;
  }

  return <>{children}</>;
}
